import type { BooleanSwitch } from "types";
import { BooleanSwitchValue } from "consts/general";
import { ECommerceOnboardingApplicationStatus } from "consts/ecommerce";
import { when } from "util/support";
import type { User } from "features/users/types";
import type { WithRequestedChangeFileds, WithRoute } from "./types";

export const isStepCompleted = (isIncomplete?: BooleanSwitch | null) => Object.is(isIncomplete, BooleanSwitchValue.Off);

export const withDetectIncomplete = (
    isIncomplete?: BooleanSwitch | null,
    requestedChangeFields: WithRequestedChangeFileds['requestedChangeFields'] = null
) => (
    when(
        isStepCompleted(isIncomplete),
        Boolean(requestedChangeFields),
        true
    )
);

export const withApplication = (route: WithRoute) =>
    (user: User) => when(
        [
            ECommerceOnboardingApplicationStatus.RequestedChanges,
            ECommerceOnboardingApplicationStatus.AwaitingReview,
            ECommerceOnboardingApplicationStatus.InReview,
            ECommerceOnboardingApplicationStatus.Rejected,
            ECommerceOnboardingApplicationStatus.Approved
        ].includes(user.onboardingStatus),
        null,
        route.Index
    );
